// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3n-0";
export var eligibilityCardNotEligible = "_3n-1";